import React from 'react';
import * as d3 from 'd3';
import $ from 'jquery';
import RcTooltip from 'rc-tooltip';
import { Network, FileText, Layers } from 'lucide-react';
import GraphCanvasShell from './graphCanvasShell';
import '../../realtime/lineage.css';
import './pipelineLineage.css';

const ACTION_ICONS = {
  externalLink: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.125 9.5H11.375C11.2755 9.5 11.1802 9.53951 11.1098 9.60983C11.0395 9.68016 11 9.77554 11 9.875V12.5H3.5V5H6.875C6.97446 5 7.06984 4.96049 7.14016 4.89016C7.21049 4.81984 7.25 4.72446 7.25 4.625V3.875C7.25 3.77554 7.21049 3.68016 7.14016 3.60984C7.06984 3.53951 6.97446 3.5 6.875 3.5H3.125C2.82663 3.5 2.54048 3.61853 2.3295 3.8295C2.11853 4.04048 2 4.32663 2 4.625V12.875C2 13.1734 2.11853 13.4595 2.3295 13.6705C2.54048 13.8815 2.82663 14 3.125 14H11.375C11.6734 14 11.9595 13.8815 12.1705 13.6705C12.3815 13.4595 12.5 13.1734 12.5 12.875V9.875C12.5 9.77554 12.4605 9.68016 12.3902 9.60983C12.3198 9.53951 12.2245 9.5 12.125 9.5ZM13.4375 2H10.4375C9.93664 2 9.68633 2.60727 10.0391 2.96094L10.8765 3.79836L5.16406 9.50867C5.11162 9.56093 5.07001 9.62303 5.04162 9.6914C5.01323 9.75977 4.99862 9.83308 4.99862 9.90711C4.99862 9.98114 5.01323 10.0544 5.04162 10.1228C5.07001 10.1912 5.11162 10.2533 5.16406 10.3055L5.69539 10.8359C5.74765 10.8884 5.80974 10.93 5.87812 10.9584C5.94649 10.9868 6.0198 11.0014 6.09383 11.0014C6.16786 11.0014 6.24117 10.9868 6.30954 10.9584C6.37791 10.93 6.44001 10.8884 6.49227 10.8359L12.2019 5.12469L13.0391 5.96094C13.3906 6.3125 14 6.06641 14 5.5625V2.5625C14 2.41332 13.9407 2.27024 13.8352 2.16475C13.7298 2.05926 13.5867 2 13.4375 2Z" fill="currentColor"/></svg>`,
  upstream: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.33331 12.0002C6.63331 12.0002 5.98054 11.8779 5.37498 11.6335C4.76942 11.3891 4.23331 11.0557 3.76665 10.6335C3.63331 10.5113 3.5722 10.3641 3.58331 10.1918C3.59442 10.0196 3.6722 9.87239 3.81665 9.75016C3.96109 9.62794 4.12776 9.56961 4.31665 9.57516C4.50554 9.58072 4.6722 9.64461 4.81665 9.76683C5.1722 10.0557 5.55831 10.2779 5.97498 10.4335C6.39165 10.5891 6.84442 10.6668 7.33331 10.6668C8.44442 10.6668 9.38887 10.2779 10.1666 9.50016C10.9444 8.72239 11.3333 7.77794 11.3333 6.66683C11.3333 5.55572 10.9444 4.61127 10.1666 3.8335C9.38887 3.05572 8.44442 2.66683 7.33331 2.66683C6.41109 2.66683 5.5972 2.94461 4.89165 3.50016C4.18609 4.05572 3.71665 4.76127 3.48331 5.61683C3.42776 5.80572 3.32776 5.97239 3.18331 6.11683C3.03887 6.26127 2.8722 6.3335 2.68331 6.3335C2.49442 6.3335 2.34165 6.2585 2.22498 6.1085C2.10831 5.9585 2.0722 5.78905 2.11665 5.60016C2.3722 4.37794 2.98054 3.36127 3.94165 2.55016C4.90276 1.73905 6.03331 1.3335 7.33331 1.3335C8.8222 1.3335 10.0833 1.85016 11.1166 2.8835C12.15 3.91683 12.6666 5.17794 12.6666 6.66683C12.6666 7.28905 12.5666 7.87516 12.3666 8.42516C12.1666 8.97516 11.8889 9.47794 11.5333 9.9335L14.2 12.6002C14.3222 12.7224 14.3833 12.8779 14.3833 13.0668C14.3833 13.2557 14.3222 13.4113 14.2 13.5335C14.0778 13.6557 13.9222 13.7168 13.7333 13.7168C13.5444 13.7168 13.3889 13.6557 13.2666 13.5335L10.6 10.8668C10.1444 11.2224 9.64165 11.5002 9.09165 11.7002C8.54165 11.9002 7.95554 12.0002 7.33331 12.0002ZM7.11665 7.56683L7.73331 5.65016C7.76665 5.56127 7.81942 5.48627 7.89165 5.42516C7.96387 5.36405 8.04998 5.3335 8.14998 5.3335H8.54998C8.63887 5.3335 8.71665 5.35572 8.78331 5.40016C8.84998 5.44461 8.90554 5.50572 8.94998 5.5835L9.83331 7.3335C9.97776 7.3335 10.0972 7.38072 10.1916 7.47516C10.2861 7.56961 10.3333 7.68905 10.3333 7.8335C10.3333 7.97794 10.2861 8.09739 10.1916 8.19183C10.0972 8.28627 9.97776 8.3335 9.83331 8.3335H9.53331C9.44442 8.3335 9.35831 8.3085 9.27498 8.2585C9.19165 8.2085 9.12776 8.13905 9.08331 8.05016L8.43331 6.76683L7.69998 9.01683C7.66665 9.11683 7.61109 9.19461 7.53331 9.25016C7.45554 9.30572 7.36665 9.3335 7.26665 9.3335H6.96665C6.86665 9.3335 6.77498 9.30294 6.69165 9.24183C6.60831 9.18072 6.54998 9.10016 6.51665 9.00016L5.56665 5.86683L4.81665 8.00016C4.78331 8.10016 4.72498 8.18072 4.64165 8.24183C4.55831 8.30294 4.46109 8.3335 4.34998 8.3335H1.83331C1.68887 8.3335 1.56942 8.28627 1.47498 8.19183C1.38054 8.09739 1.33331 7.97794 1.33331 7.8335C1.33331 7.68905 1.38054 7.56961 1.47498 7.47516C1.56942 7.38072 1.68887 7.3335 1.83331 7.3335H3.99998L4.98331 4.4835C5.01665 4.3835 5.07498 4.30572 5.15831 4.25016C5.24165 4.19461 5.33331 4.16683 5.43331 4.16683H5.74998C5.86109 4.16683 5.95554 4.20016 6.03331 4.26683C6.11109 4.3335 6.16665 4.41683 6.19998 4.51683L7.11665 7.56683Z" fill="currentColor"/></svg>`,
  downstream: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.8666 5.9335L15 8.06683L14.0666 9.00016L11.9333 6.86683C11.7 7.00016 11.45 7.11127 11.1833 7.20016C10.9166 7.28905 10.6333 7.3335 10.3333 7.3335C9.49998 7.3335 8.79165 7.04183 8.20831 6.4585C7.62498 5.87516 7.33331 5.16683 7.33331 4.3335C7.33331 3.50016 7.62498 2.79183 8.20831 2.2085C8.79165 1.62516 9.49998 1.3335 10.3333 1.3335C11.1666 1.3335 11.875 1.62516 12.4583 2.2085C13.0416 2.79183 13.3333 3.50016 13.3333 4.3335C13.3333 4.6335 13.2889 4.91683 13.2 5.1835C13.1111 5.45016 13 5.70016 12.8666 5.9335ZM10.3333 6.00016C10.8 6.00016 11.1944 5.83905 11.5166 5.51683C11.8389 5.19461 12 4.80016 12 4.3335C12 3.86683 11.8389 3.47238 11.5166 3.15016C11.1944 2.82794 10.8 2.66683 10.3333 2.66683C9.86665 2.66683 9.4722 2.82794 9.14998 3.15016C8.82776 3.47238 8.66665 3.86683 8.66665 4.3335C8.66665 4.80016 8.82776 5.19461 9.14998 5.51683C9.4722 5.83905 9.86665 6.00016 10.3333 6.00016ZM11.6333 8.46683L13.3333 10.1668V13.3335C13.3333 13.7002 13.2028 14.0141 12.9416 14.2752C12.6805 14.5363 12.3666 14.6668 12 14.6668H2.66665C2.29998 14.6668 1.98609 14.5363 1.72498 14.2752C1.46387 14.0141 1.33331 13.7002 1.33331 13.3335V4.00016C1.33331 3.6335 1.46387 3.31961 1.72498 3.0585C1.98609 2.79738 2.29998 2.66683 2.66665 2.66683H6.33331C6.21109 2.94461 6.12776 3.23072 6.08331 3.52516C6.03887 3.81961 6.01665 4.11127 6.01665 4.40016C6.01665 5.61127 6.44442 6.62238 7.29998 7.4335C8.15554 8.24461 9.1722 8.65016 10.35 8.65016C10.5611 8.65016 10.7722 8.63627 10.9833 8.6085C11.1944 8.58072 11.4111 8.5335 11.6333 8.46683Z" fill="currentColor"/></svg>`,
};

const PADDING = 80;
const H_GAP = 360;
const MIN_NODE_W = 200;
const MAX_NODE_W = 380;
const NODE_HEADER_H = 52;
const SECTION_LABEL_H = 28;
const ROW_H = 30;
const NODE_PAD_Y = 18;

function truncateText(text, maxLength = 28) {
  const value = String(text || '');
  if (value.length <= maxLength) return value;
  return `${value.substring(0, maxLength - 3)}...`;
}

function asList(value) {
  if (Array.isArray(value)) return value;
  if (!value || typeof value !== 'object') return [];
  const values = Object.values(value);
  if (values.length && values.every((item) => item && typeof item === 'object' && !Array.isArray(item))) {
    return values;
  }
  return [value];
}

function itemFailed(item) {
  if (!item || typeof item !== 'object') return false;
  if (item.is_error === true || item.isError === true) return true;
  const status = String(item.status || item.run_status || item.task_status || '');
  return /fail|error/i.test(status);
}

function nodeIsError(data, nodeName, tasks, datasets) {
  if (data?.is_error === true && (!data.pipeline_name || nodeName === data.pipeline_name)) return true;
  if (data?.is_error && typeof data.is_error === 'object' && data.is_error[nodeName]) return true;
  if (asList(tasks).some(itemFailed)) return true;
  if (asList(datasets).some(itemFailed)) return true;
  return false;
}

function measureNode(name, tasks, datasets) {
  const taskList = asList(tasks);
  const datasetList = asList(datasets);
  const taskcnt = taskList.length;
  const datasetcnt = datasetList.length;
  const hasContent = taskcnt > 0 || datasetcnt > 0;
  const height = hasContent
    ? NODE_HEADER_H
      + (taskcnt > 0 ? SECTION_LABEL_H + (taskcnt * ROW_H) : 0)
      + (datasetcnt > 0 ? SECTION_LABEL_H + (datasetcnt * ROW_H) : 0)
      + NODE_PAD_Y
    : 48;

  let width = Math.max(MIN_NODE_W, (String(name).length * 8) + 56);
  taskList.forEach((task) => {
    width = Math.max(width, ((task?.task_name || '').length * 7.5) + 72);
  });
  datasetList.forEach((dataset) => {
    width = Math.max(width, ((dataset?.pipeline_data_set_name || '').length * 7.5) + 72);
  });

  return {
    width: Math.min(width, MAX_NODE_W),
    height,
    taskcnt,
    datasetcnt,
  };
}

function buildGraphTree(graph) {
  const nodesMap = new Map();
  const links = asList(graph.links);
  const allNodeNames = new Set([
    ...Object.keys(graph.tasks || {}),
    ...links.flatMap((link) => [link?.source, link?.destination]),
    ...Object.keys(graph.datasets || {}),
  ]);

  allNodeNames.forEach((key) => {
    if (!key) return;
    const tasks = graph.tasks?.[key];
    const datasets = graph.datasets?.[key];
    const size = measureNode(key, tasks, datasets);
    nodesMap.set(key, {
      name: key,
      contentwidth: size.width,
      contentheight: size.height,
      contenttaskcnt: size.taskcnt,
      contentdatasetcnt: size.datasetcnt,
      children: [],
    });
  });

  if (!nodesMap.size) return null;

  if (links.length === 0) {
    const rootName = graph.pipeline_name && nodesMap.has(graph.pipeline_name)
      ? graph.pipeline_name
      : Array.from(nodesMap.keys())[0];
    return nodesMap.get(rootName) || null;
  }

  const destinationSet = new Set(links.map((link) => link?.destination));
  const allSources = new Set(links.map((link) => link?.source));
  const rootNodeNames = Array.from(allSources).filter((src) => !destinationSet.has(src));

  const visited = new Set();
  links.forEach((link) => {
    const sourceNode = nodesMap.get(link.source);
    const targetNode = nodesMap.get(link.destination);
    if (sourceNode && targetNode && !visited.has(targetNode.name)) {
      sourceNode.children.push(targetNode);
      visited.add(targetNode.name);
    }
  });

  const childNames = new Set();
  nodesMap.forEach((node) => {
    node.children.forEach((child) => childNames.add(child.name));
  });
  const disconnectedNodes = Array.from(nodesMap.keys()).filter(
    (name) => !childNames.has(name) && !rootNodeNames.includes(name)
  );

  if (rootNodeNames.length + disconnectedNodes.length > 1) {
    const uniqueNames = Array.from(new Set([...rootNodeNames, ...disconnectedNodes]))
      .filter((name) => !childNames.has(name));
    return {
      name: 'ROOT',
      contentwidth: 0,
      contentheight: 0,
      contenttaskcnt: 0,
      contentdatasetcnt: 0,
      children: uniqueNames.map((name) => nodesMap.get(name)).filter(Boolean),
    };
  }

  if (rootNodeNames.length === 1) return nodesMap.get(rootNodeNames[0]);
  if (nodesMap.size === 1) return nodesMap.get(Array.from(nodesMap.keys())[0]);
  return null;
}

function computeLayout(data) {
  if (!data || !data.tasks) {
    return { nodes: [], edges: [], canvasW: 1200, canvasH: 700, posMap: {}, cards: [] };
  }

  const treeSource = buildGraphTree(data);
  if (!treeSource) {
    return { nodes: [], edges: [], canvasW: 1200, canvasH: 700, posMap: {}, cards: [] };
  }

  const roots = treeSource.name === 'ROOT' && Array.isArray(treeSource.children)
    ? treeSource.children
    : [treeSource];
  const virtualRoot = { name: '__VIRTUAL_ROOT__', children: roots };
  const root = d3.hierarchy(virtualRoot);

  const hasContentNodes = root.descendants().some(
    (node) => node.data && (node.data.contenttaskcnt > 0 || node.data.contentdatasetcnt > 0)
  );
  const dynamicNodeHeight = hasContentNodes ? 48 : 36;

  const treeLayout = d3.tree()
    .nodeSize([dynamicNodeHeight, H_GAP])
    .separation((a, b) => {
      const aHeight = a.data?.contentheight || 48;
      const bHeight = b.data?.contentheight || 48;
      const aWidth = a.data?.contentwidth || MIN_NODE_W;
      const bWidth = b.data?.contentwidth || MIN_NODE_W;
      // Separation is a multiplier of nodeSize[0]; size by content height so cards don't overlap
      const heightSeparation = Math.max(1.15, ((aHeight + bHeight) / 2) / dynamicNodeHeight);
      const widthSeparation = Math.max(1.1, ((aWidth + bWidth) / 2) / 220);
      return Math.max(heightSeparation, widthSeparation);
    });

  const treeData = treeLayout(root);
  const placed = treeData.descendants().filter(
    (d) => d.data.name !== 'ROOT' && d.data.name !== '__VIRTUAL_ROOT__'
  );

  const rawNodes = placed.map((d) => {
    const name = d.data.name;
    const tasks = asList(data.tasks?.[name]);
    const datasets = asList(data.datasets?.[name]);
    const w = d.data.contentwidth || MIN_NODE_W;
    const h = d.data.contentheight || 80;
    const x = d.y;
    const y = d.x - h / 2;
    return {
      id: name,
      name,
      x,
      y,
      w,
      h,
      tasks,
      datasets,
      isError: nodeIsError(data, name, tasks, datasets),
    };
  });

  let minX = Infinity;
  let minY = Infinity;
  rawNodes.forEach((n) => {
    minX = Math.min(minX, n.x);
    minY = Math.min(minY, n.y);
  });
  if (!Number.isFinite(minX)) minX = 0;
  if (!Number.isFinite(minY)) minY = 0;

  const nodes = rawNodes.map((n) => {
    const x = n.x - minX + PADDING;
    const y = n.y - minY + PADDING;
    return {
      ...n,
      x,
      y,
      cx: x + n.w,
      cy: y + n.h / 2,
      lx: x,
      ly: y + n.h / 2,
    };
  });

  const byName = new Map(nodes.map((n) => [n.name, n]));
  const edges = asList(data.links)
    .map((link, idx) => {
      const source = byName.get(link.source);
      const target = byName.get(link.destination);
      if (!source || !target) return null;
      const dx = Math.max(60, (target.lx - source.cx) / 2);
      const path = `M${source.cx} ${source.cy} C${source.cx + dx} ${source.cy}, ${target.lx - dx} ${target.ly}, ${target.lx} ${target.ly}`;
      return {
        id: `e-${idx}-${link.source}-${link.destination}`,
        source: link.source,
        target: link.destination,
        path,
      };
    })
    .filter(Boolean);

  let maxX = 0;
  let maxY = 0;
  nodes.forEach((n) => {
    maxX = Math.max(maxX, n.x + n.w);
    maxY = Math.max(maxY, n.y + n.h);
  });

  const canvasW = Math.max(1000, Math.ceil(maxX + PADDING));
  const canvasH = Math.max(600, Math.ceil(maxY + PADDING));

  const posMap = {};
  const cards = nodes.map((n) => {
    posMap[n.id] = { x: n.x, y: n.y, w: n.w, h: n.h };
    return {
      id: n.id,
      type: 'pipe',
      status: n.isError ? 'critical' : 'normal',
    };
  });

  return { nodes, edges, canvasW, canvasH, posMap, cards };
}

function JobNodeCard({
  node,
  isFocus,
  highlightMode,
  relatedNames,
  onUpstream,
  onDownstream,
  onExternal,
}) {
  const isRelated = relatedNames.has(node.name);
  const isDimmed = highlightMode && !isRelated && !isFocus;

  let cardClass = 'pl-card';
  if (node.isError) cardClass += ' pl-card--error';
  if (isFocus || (highlightMode === 'self' && isRelated)) cardClass += ' pl-card--active';
  if (highlightMode === 'upstream' && isRelated) cardClass += ' pl-card--upstream';
  if (highlightMode === 'downstream' && isRelated) cardClass += ' pl-card--downstream';
  if (isDimmed) cardClass += ' pl-card--dimmed';

  const renderActions = () => (
    <div className="pl-item__actions">
      <div className="pl-item__actions-left">
        <RcTooltip placement="top" overlay={<span>Upstream</span>}>
          <button
            type="button"
            className="pl-action upstream"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onUpstream(node.name);
            }}
            dangerouslySetInnerHTML={{ __html: ACTION_ICONS.upstream }}
          />
        </RcTooltip>
        <RcTooltip placement="top" overlay={<span>Downstream</span>}>
          <button
            type="button"
            className="pl-action downstream"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDownstream(node.name);
            }}
            dangerouslySetInnerHTML={{ __html: ACTION_ICONS.downstream }}
          />
        </RcTooltip>
      </div>
      <span className="pl-item__actions-sep" />
      <RcTooltip placement="top" overlay={<span>Details</span>}>
        <button
          type="button"
          className="pl-action rightpaneldetail"
          dangerouslySetInnerHTML={{ __html: ACTION_ICONS.externalLink }}
        />
      </RcTooltip>
    </div>
  );

  return (
    <div
      className={`pipeline-lineage-node${isFocus ? ' is-focus' : ''}`}
      style={{ left: node.x, top: node.y, width: node.w }}
      data-node={node.name}
    >
      <div className={cardClass} id={node.name}>
        <div className="pl-card__head">
          <span className="pl-card__ico">
            <Network size={13} />
          </span>
          <span className="pl-card__name" title={node.name}>{truncateText(node.name, 26)}</span>
          <span className="pl-card__type">{node.isError ? 'ERROR' : 'JOB'}</span>
        </div>

        {(node.tasks.length > 0 || node.datasets.length > 0) && (
          <div className="pl-card__body">
            {node.tasks.length > 0 && (
              <div className="pl-sec">
                <div className="pl-sec__lbl">Tasks</div>
                {node.tasks.map((task) => (
                  <div
                    className="pl-item"
                    key={task.task_id || task.task_name}
                    onClick={(e) => {
                      e.preventDefault();
                      onExternal({ name: node.name, type: 'task', selected: task });
                    }}
                  >
                    <span className="pl-item__ico"><FileText size={13} /></span>
                    <span className="pl-item__text">{task.task_name}</span>
                    {renderActions()}
                  </div>
                ))}
              </div>
            )}

            {node.datasets.length > 0 && (
              <div className="pl-sec">
                <div className="pl-sec__lbl">Datasets</div>
                {node.datasets.map((dataset) => (
                  <div
                    className="pl-item"
                    key={dataset.lineage_dataset_id || dataset.pipeline_data_set_name}
                    onClick={(e) => {
                      e.preventDefault();
                      onExternal({ name: node.name, type: 'dataset', selected: dataset });
                    }}
                  >
                    <span className="pl-item__ico"><Layers size={13} /></span>
                    <span className="pl-item__text">
                      {dataset.pipeline_data_set_name}
                    </span>
                    {renderActions()}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default class PipelineLineage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlightMode: null,
      relatedNames: new Set(),
      activeNode: props.focusNode || props.data?.pipeline_name || null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.focusNode !== this.props.focusNode && this.props.focusNode) {
      this.setState({ activeNode: this.props.focusNode });
    }
  }

  getRelatedNames = (nodeName, type) => {
    const links = this.props.data?.links || [];
    const related = new Set([nodeName]);
    const queue = [nodeName];
    const visited = new Set([nodeName]);

    while (queue.length) {
      const current = queue.shift();
      links.forEach((link) => {
        const next = type === 'upstream'
          ? (link.destination === current ? link.source : null)
          : (link.source === current ? link.destination : null);
        if (next && !visited.has(next)) {
          visited.add(next);
          related.add(next);
          queue.push(next);
        }
      });
    }
    return related;
  };

  handleUpstream = (nodeName) => {
    this.setState({
      highlightMode: 'upstream',
      relatedNames: this.getRelatedNames(nodeName, 'upstream'),
      activeNode: nodeName,
    });
  };

  handleDownstream = (nodeName) => {
    this.setState({
      highlightMode: 'downstream',
      relatedNames: this.getRelatedNames(nodeName, 'downstream'),
      activeNode: nodeName,
    });
  };

  handleExternal = (payload) => {
    const { handleExternalLinkClick, error } = this.props;
    this.setState({
      activeNode: payload?.name || this.state.activeNode,
      highlightMode: null,
      relatedNames: new Set(),
    });
    try {
      $('.lineage-graph-sidebar').addClass('show');
    } catch (e) {
      // ignore
    }
    if (typeof handleExternalLinkClick === 'function') {
      handleExternalLinkClick(payload, error);
    }
  };

  clearHighlight = () => {
    if (!this.state.highlightMode) return;
    this.setState({ highlightMode: null, relatedNames: new Set() });
  };

  render() {
    const {
      data,
      height = 'calc(100vh - 78px)',
      chart_id = 'linenage',
      lineageGraphExpanded,
      focusNode,
      error,
      theme = 'light',
    } = this.props;

    if (!data || !data.tasks) {
      return (
        <div id={chart_id} className="lineage-graph-container" style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ color: '#64748b' }}>No lineage data available</span>
        </div>
      );
    }

    let layout;
    try {
      layout = computeLayout(data);
    } catch (layoutError) {
      console.error("Unable to draw pipeline lineage:", layoutError);
      return (
        <div id={chart_id} className="lineage-graph-container" style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ color: '#64748b' }}>No lineage data available</span>
        </div>
      );
    }
    const focusName = this.state.activeNode || focusNode || data.pipeline_name;
    const contentKey = [
      chart_id,
      data.pipeline_name || '',
      layout.nodes.length,
      layout.edges.length,
      lineageGraphExpanded ? 'exp' : 'col',
      error ? 'err' : 'ok',
    ].join('-');

    return (
      <div id={chart_id} className="lineage-graph-container" style={{ height, position: 'relative' }}>
        <GraphCanvasShell
          show
          embedded
          hideHeader
          autoFit
          height="100%"
          defaultTheme={theme === 'dark' ? 'dark' : 'light'}
          canvasW={layout.canvasW}
          canvasH={layout.canvasH}
          cards={layout.cards}
          posMap={layout.posMap}
          contentKey={contentKey}
          focusId={focusName}
        >
          <svg
            className="pipeline-lineage-edges"
            width={layout.canvasW}
            height={layout.canvasH}
            onClick={this.clearHighlight}
          >
            <defs>
              <marker id={`${chart_id}-arrow`} viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7" orient="auto">
                <path d="M0,1.5 L8,5 L0,8.5 z" fill="#C4B5FD" />
              </marker>
              <marker id={`${chart_id}-arrow-active`} viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7" orient="auto">
                <path d="M0,1.5 L8,5 L0,8.5 z" fill="#6366F1" />
              </marker>
              <marker id={`${chart_id}-arrow-error`} viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7" orient="auto">
                <path d="M0,1.5 L8,5 L0,8.5 z" fill="#F64E60" />
              </marker>
            </defs>
            {layout.edges.map((edge) => {
              const related = this.state.highlightMode
                && this.state.relatedNames.has(edge.source)
                && this.state.relatedNames.has(edge.target);
              const sourceNode = layout.nodes.find((n) => n.name === edge.source);
              const isErrorEdge = sourceNode?.isError;
              let className = 'pipeline-lineage-edge';
              let marker = `url(#${chart_id}-arrow)`;
              if (related) {
                className += ' is-active';
                marker = `url(#${chart_id}-arrow-active)`;
              } else if (isErrorEdge && error) {
                className += ' is-error';
                marker = `url(#${chart_id}-arrow-error)`;
              }
              return (
                <path
                  key={edge.id}
                  className={className}
                  d={edge.path}
                  markerEnd={marker}
                />
              );
            })}
          </svg>

          {layout.nodes.map((node) => (
            <JobNodeCard
              key={node.id}
              node={node}
              isFocus={node.name === focusName}
              highlightMode={this.state.highlightMode}
              relatedNames={this.state.relatedNames}
              onUpstream={this.handleUpstream}
              onDownstream={this.handleDownstream}
              onExternal={this.handleExternal}
            />
          ))}
        </GraphCanvasShell>
      </div>
    );
  }
}
